import { storage, OIDC_METADATA } from '../app/Storage';

const openIdConnectMetadataUrlPath = '.well-known/openid-configuration';

export class Metadata {
    clientConfiguration;
    openIdConfiguration;

    constructor(clientConfiguration) {
        this.clientConfiguration = clientConfiguration;
        this.openIdConfiguration = {};
    }

    // Client properties
    get authority() {
        return this.clientConfiguration.authority;
    }
    get client_id() {
        return this.clientConfiguration.client_id;
    }
    get redirect_uri() {
        return this.clientConfiguration.redirect_uri;
    }
    get silent_redirect_uri() {
        return this.clientConfiguration.silent_redirect_uri;
    }
    get post_logout_redirect_uri() {
        return this.clientConfiguration.post_logout_redirect_uri;
    }
    get manage_account_redirect_uri() {
        return this.clientConfiguration.manage_account_redirect_uri;
    }

    // OpenId Connect properties
    get defaultResponseType() {
        // FIXME Só permite usar um tipo de response_type
        return this.openIdConfiguration.response_types_supported[0];
    }

    get authorizationEndpoint() {
        return this.openIdConfiguration.authorization_endpoint;
    }

    get tokenEndpoint() {
        return this.openIdConfiguration.token_endpoint;
    }

    get signoutEndpoint() {
        return this.openIdConfiguration.end_session_endpoint;
    }

    get userInfoEndpoint() {
        return this.openIdConfiguration.userinfo_endpoint;
    }

    // Signature keys properties
    get contentSignAlgorithm() {
        return this.openIdConfiguration.keys.alg;
    }

    get signingCertificate() {
        return this.certToPEM(this.openIdConfiguration.keys.x5c[0]);
    }

    loadOpenIdMetadata() {
        let fromStorage = storage.get(OIDC_METADATA);
        let configuration = {};

        if (fromStorage) {
            let json = JSON.parse(fromStorage);
            this.openIdConfiguration = Object.assign(configuration, json);
            return Promise.resolve();
        }

        let metadataUrl = this.authority + openIdConnectMetadataUrlPath;
        return fetch(metadataUrl, {
            method: "GET"
        }).then((response) => {
            return response.json();
        }).then((json) => {
            let config = {};
            configuration = Object.assign(config, json);
            return fetch(configuration.jwks_uri, { method: "GET" });
        }).then((response) => {
            return response.json();
        }).then((json) => {
            // TODO Aqui este any devia ser JSON mas depois não se consegue aceder ao json.keys[0]
            let keys = {};
            let keySettings = Object.assign(keys, json.keys[0]);
            configuration.keys = keySettings;
            storage.set(OIDC_METADATA, JSON.stringify(configuration));
            this.openIdConfiguration = configuration;
        }).catch((error) => {
            throw error;
        });
    }

    certToPEM(cert) {
        cert = `-----BEGIN CERTIFICATE-----\n${cert}\n-----END CERTIFICATE-----\n`;
        return cert;
    };
}